
import { Injectable } from '@angular/core';

import Swal, { SweetAlertIcon, SweetAlertResult } from 'sweetalert2';

export class Button {
  show?: boolean;
  text?: string;
  color?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor() {}

  alertYhosu(message:any, type:any, buttons?:any, messages?:any, errors?:any, close?:boolean) {
   /// console.log(message, type, buttons, messages, errors);
    let title = 'Error';
    let text = message || 'Error';
    if(this.lengthItems(messages)) {
      title = message;
      text = this.textFormat(messages);
    } else {
      title = message || 'Error';
      if(messages != null) {
        text = messages;
      }
    }
    if(this.lengthItems(errors)) {
      title = message;
      if(this.lengthItems(text)) {
        text = text ? text : text + '<hr>' + this.textFormat(errors);
      } else {
        text = this.textFormat(errors);
      }
    } else {
      if(message) {
        title = 'Error';
        text = message;
      }
      if(errors != null) {
        title = message || 'Error';
        text = errors;
      }
    }
    Swal.fire({
      title: title,
      html: text,
      icon: type,
      showCancelButton: buttons ? (buttons['showCancelButton'] ? buttons['showCancelButton'] : false) : false,
      cancelButtonText: buttons ? (buttons['cancelButtonText'] ? buttons['cancelButtonText'] : null) : null,
      showConfirmButton: buttons ? (buttons['showConfirmButton'] ? buttons['showConfirmButton'] : false) : false,
      confirmButtonText: buttons ? (buttons['confirmButtonText'] ? buttons['confirmButtonText'] : null) : null,
      allowOutsideClick: (close ==  true || close == false) ? (close == false ? false : true) : true,
      allowEscapeKey: (close ==  true || close == false) ? (close == false ? false : true) : true,
    });
  }

  alertCapYei({
    type,
    message,
    buttons = {
      cancel: {
        show: true,
        text: 'Cancelar',
        color: '#ff6862',
      },
      confirm: {
        show: true,
        text: 'Aceptar',
        color: 'var(--primary-color)',
      },
    },
    description,
    close = true,
  }: {
    type: SweetAlertIcon,
    message: string,
    buttons?: { cancel?: Button, confirm?: Button, deny?: Button },
    description?: any,
    close?:boolean,
  }): Promise<SweetAlertResult<any>> {
    // console.log(message, type, buttons, description);
    let title = message || 'Error';
    let text = description || 'Error';

    if(this.lengthItems(description)) {
      title = message;
      text = this.textFormat(description);
    } else {
      if(typeof description === 'string') {
        text = description;
      } else {
        title = 'Error';
        text = message;
      }

    }

    return Swal.fire({
      title: title,
      html: text,
      icon: type,

      showCancelButton: buttons?.cancel?.show ?? true,
      cancelButtonText: buttons?.cancel?.text ?? 'Cancelar',
      cancelButtonColor: buttons?.cancel?.color ?? '#ff6862',

      showConfirmButton: buttons?.confirm?.show ?? true,
      confirmButtonText: buttons?.confirm?.text ?? 'Aceptar',
      confirmButtonColor: buttons?.confirm?.color ?? 'var(--primary-color)',

      showDenyButton: buttons?.deny?.show ?? false,
      denyButtonText: buttons?.deny?.text ?? 'Rechazar',
      denyButtonColor: buttons?.deny?.color ?? '#222',

      allowOutsideClick: close,
      allowEscapeKey: close,
    });
  }

  private textFormat(messages: any[]) {
    return messages.map(item => `<p>${item}</p>`).join('');
  }

  private lengthItems(items: any) {
    if(Array.isArray(items)) {
      if(items.length >= 1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
